import { render, staticRenderFns } from "./DeliveryOptionSelector.vue?vue&type=template&id=82d0da26&"
import script from "./DeliveryOptionSelector.vue?vue&type=script&lang=js&"
export * from "./DeliveryOptionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports